import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dropdown_container" }
const _hoisted_2 = { class: "dropdown_wrapper" }
const _hoisted_3 = { class: "dropdown_wrapper_name" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("修改密码")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("登出")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_dropdown, { trigger: ['click'] }, {
      overlay: _withCtx(() => [
        _createVNode(_component_a_menu, { onClick: _ctx.menuClick }, {
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, { key: "password" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "logout" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_a_avatar, {
            size: 32,
            src: _ctx.avatarUrl
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.userName), 1),
          _createVNode(_component_svg_icon, {
            class: "dropdown_wrapper_svg",
            "icon-name": "CaretDownOutlined"
          })
        ])
      ]),
      _: 1
    })
  ]))
}